var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCalendarMisaligned = function SvgCalendarMisaligned(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M3.833 2.944c0-.501.414-.944.945-.944.502 0 .944.443.944.944v.945H9.5v-.945c0-.501.413-.944.944-.944.502 0 .945.443.945.944v.945h1.417c.767 0 1.416.65 1.416 1.417v1.416H1V5.306c0-.768.62-1.417 1.417-1.417h1.416zm10.39 4.752c-.178 0-.325-.03-.473-.03a5.183 5.183 0 0 0-5.194 5.195c0 1.77.855 3.335 2.184 4.25H2.417c-.797 0-1.417-.62-1.417-1.417V7.668h13.222zM18 12.861a4.25 4.25 0 0 1-4.25 4.25 4.23 4.23 0 0 1-4.25-4.25 4.25 4.25 0 0 1 4.25-4.25c2.332 0 4.25 1.918 4.25 4.25m-4.752-1.889v1.89c0 .265.236.471.473.471h1.446a.485.485 0 0 0 .472-.472.51.51 0 0 0-.472-.472h-.974v-1.417a.485.485 0 0 0-.473-.472.51.51 0 0 0-.472.472"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarMisaligned);
export default ForwardRef;